export const detectPrecision = (num: string | number = 0) => {
  const [, right] = String(num).split('.');

  if (right) return right.length;

  return 0;
};
